module.exports = __webpack_public_path__ + "static/media/account.00c26329.svg";